import React from 'react'
import styles from './Terms.module.css'

export default function Terms() {
  return (
    <main className={styles.main}>
      <div className={styles.container}>
        <h1 className={styles.title}>Terms of Service</h1>
        <div className={styles.content}>
          <p>
            VerifyLink is a privacy-first identity verification preparation platform. By using our
            service, you agree to these terms.
          </p>
          <h2>Service Description</h2>
          <p>
            VerifyLink allows users to prepare verification documents by capturing or uploading
            files, encrypting them locally, and transferring them to an Android device. The service
            also supports phone mirroring and webcam replacement for identity verification workflows.
          </p>
          <h2>User Responsibilities</h2>
          <p>
            You are responsible for ensuring you have the right to capture and transfer any
            documents or images you upload. You must not use VerifyLink for illegal purposes.
          </p>
          <h2>Data and Privacy</h2>
          <p>
            All files are encrypted in your browser using AES-256-GCM before being uploaded. We do
            not have access to your encryption keys and cannot decrypt your files. Files are
            automatically deleted after 15 minutes.
          </p>
          <h2>Limitations</h2>
          <p>
            VerifyLink is provided as-is without warranties. We are not responsible for the outcome
            of any third-party verification service.
          </p>
        </div>
      </div>
    </main>
  )
}
